import { render, staticRenderFns } from "./coffee-card-list-shell-home.vue?vue&type=template&id=052550e3&scoped=true&"
import script from "./coffee-card-list-shell-home.vue?vue&type=script&lang=js&"
export * from "./coffee-card-list-shell-home.vue?vue&type=script&lang=js&"
import style0 from "./coffee-card-list-shell-home.vue?vue&type=style&index=0&id=052550e3&prod&lang=scss&scoped=true&"
import style1 from "./coffee-card-list-shell-home.vue?vue&type=style&index=1&id=052550e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "052550e3",
  null
  
)

export default component.exports